import * as React from "react";
import { Button, Modal, Space } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./ValidationWarningModal.css";

export interface ValidationWarningModalProps {
  open: boolean;
  title: string;
  message: string;
  okText?: string;
  cancelText?: string;
  onOk: () => void;
  onCancel: () => void;
  zIndex?: number;
}

const ValidationWarningModal: React.FC<ValidationWarningModalProps> = ({
  open,
  title,
  message,
  okText = "OK",
  cancelText = "Cancel",
  onOk,
  onCancel,
  zIndex = 1000,
}) => (
  <Modal
    open={open}
    onCancel={onCancel}
    footer={
      <Space className="validation-warning-modal-footer" size="small">
        <Button className="validation-warning-modal-btn-cancel" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button type="primary" className="validation-warning-modal-btn-ok" onClick={onOk}>
          {okText}
        </Button>
      </Space>
    }
    closable
    closeIcon={<CloseOutlined className="validation-warning-modal-close" />}
    mask={{ closable: false }}
    keyboard={false}
    centered
    width={440}
    zIndex={zIndex}
    className="validation-warning-modal"
    title={
      <div className="validation-warning-modal-title-row">
        <span className="validation-warning-modal-icon" aria-hidden>
          !
        </span>
        <span className="validation-warning-modal-title-text">{title}</span>
      </div>
    }
  >
    <p className="validation-warning-modal-message">{message}</p>
  </Modal>
);

export default ValidationWarningModal;